export const TEXT_ALREADY_REROLLED = 'Вы уже перебрасывали кости урона этого отряда!';
export const TEXT_UNIT_HAS_NO_ADDITIONAL_SUPPLY = 'У отряда нет дополнительного снабжения для переброса костей!';
export const TEXT_CHOOSE_DICES_TO_REROLL = 'Выберите кости урона, которые хотите перебросить';
// Обучение: сценарий ждет переброса определенного числа костей (глава 3 — обеих)
export const buildTextRerollDiceCountRequired = (requiredCount, selectedCount) => (
  `Для переброса нужно выбрать ${requiredCount} кубика, а не ${selectedCount}`
);
export const TEXT_UNIT_ALREADY_HAS_BEST_DAMAGE_RESULT = 'У этого отряда уже лучший возможный результат урона';
export const TEXT_UNIT_ALREADY_HAS_BUILDING_DAMAGE_RESULT = 'У этого отряда уже достаточный для повреждения строения результат';
export const TEXT_TARGET_UNIT_ALREADY_KILLED = 'Выбранный отряд противника уже уничтожен';
export const TEXT_DICE_ALREADY_BEST = 'Эта кость уже с лучшим возможным результатом!';
export const TEXT_CHOOSE_MELEE_PRIORITY_TARGET = 'Выберите приоритетную цель для отряда';
export const TEXT_CHOOSE_MELEE_PRIORITY_TARGET_NO_DAMAGE = 'Нельзя выбрать приоритетную цель - этот отряд не нанес урон';
export const TEXT_CHOOSE_MELEE_PRIORITY_TARGET_ONLY_ONE_TARGET = 'Нельзя выбрать приоритетную цель - у отряд только один смежный противник';
export const TEXT_YOU_CANNOT_REROLL_ENEMY_DICES = 'Нельзя перебрасывать кости вражеских отрядов';
export const TEXT_COMBAT_STAGE_WAIT_OTHERS = 'Подождите, другие игроки еще не подтвердили завершение этапа ближнего боя'





